import { useEffect, useRef } from 'react'
import { useRouter } from 'next/router'
import { document } from '@mtsbank/ui-kit'

interface RouteEvent {
  url: string
  timestamp: number
}

let lastRoute: RouteEvent | null = null

export const getPreviousRoute = () => (lastRoute?.url !== undefined ? lastRoute?.url : document.referrer)

export const usePreviousRoute = () => {
  const router = useRouter()
  const previousRouteRef = useRef<string>(null)

  useEffect(() => {
    const handleRouteChange = () => {
      previousRouteRef.current = router.asPath
      lastRoute = {
        url: router.asPath,
        timestamp: Date.now(),
      }
    }

    router.events.on('routeChangeStart', handleRouteChange)

    return () => {
      router.events.off('routeChangeStart', handleRouteChange)
    }
  }, [router])

  return previousRouteRef.current
}
